import React, { useState, useEffect } from "react"

import Grid from "@material-ui/core/Grid"

import { HomeState } from "../store/home"

import api from "../services/api"
import { useNavigation } from "../services/navigation"
import {
	makePredefinedRedirectIfNeeded,
	makeCallbackRedirectIfNeeded,
	makePageRefreshIfNeeded
} from "../services/redirects"
import { clearAllServiceWorkerCache } from "../services/cache"
import { notifyLoginBlockIfNeeded } from "../services/notification"

import Loading from "../components/Loading"	
import Navbar from "../components/Navbar"
import Cover from "../components/Cover"

import HomeRoutes from "../routes/home"

const Main = () => {
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)
	const [data, setData] = useState({})

	const { getParsedQueryParams, getRouteParams } = useNavigation()

	const { hash } = getRouteParams()

	const setGlobalState = object => {
		setData({
			...data,
			object
		})
	}

	const setPageInfo = data => {
		document.title = `${data.customer.name} - ${data.gallery.title}`

		let manifestElement = document.getElementById("app-manifest")
		if (!manifestElement) {
			manifestElement = document.createElement("link")
			manifestElement.id = "app-manifest"
			manifestElement.rel = "manifest"
			document.head.appendChild(manifestElement)
		}

		const icons = []
		const sizes = ["192x192", "256x256", "512x512"]

		if (data.gallery.cover) {
			sizes.forEach(size => {
				icons.push({ src: data.gallery.cover, sizes: size, type: "image/png" })
			})

			let iphoneIconElement = document.getElementById("iphone-icon")
			if (!iphoneIconElement) {
				iphoneIconElement = document.createElement("link")
				iphoneIconElement.id = "iphone-icon"
				iphoneIconElement.rel = "apple-touch-icon"
				iphoneIconElement.href = data.gallery.cover
				document.head.appendChild(iphoneIconElement)
			}
		}

		const manifest = {
			name: data.gallery.title,
			short_name: data.gallery.title,
			display: "standalone",
			description: `${data.gallery.title} por ${data.customer.name}.`,
			background_color: "#f2f2f2",
			theme_color: "#f8f8f8",
			start_url: window.location.origin + "/index.html/" + data.front.hash,
			icons
		}

		const blob = new Blob([JSON.stringify(manifest)], {
			type: "application/json"
		})
		const url = URL.createObjectURL(blob)
		manifestElement.setAttribute("href", url)
	}

	const getData = async () => {
		setLoading(true)

		try {
			await makePredefinedRedirectIfNeeded()

			const { data } = await api.get(`/home/data?hash=${hash}`)

			const parsedQueryParams = getParsedQueryParams()

			await makeCallbackRedirectIfNeeded(parsedQueryParams, data.front)

			await makePageRefreshIfNeeded(data.front, data.customer, hash)

			notifyLoginBlockIfNeeded(data.front)

			setData({
				...data,
				setGlobalState
			})
			setPageInfo(data)

			await clearAllServiceWorkerCache().catch(() => {})
		} catch (error) {
			setError("Galeria não encontrada")
		}

		setLoading(false)
	}

	useEffect(() => {
		getData()
	}, [])

	return (
		<HomeState.Provider value={data}>
			<Loading loading={loading} error={error}>
				<Grid container spacing={0}>
					<Grid item xs={12} sm={12} md={4} lg={3} xl={3} style={{ height: "100%" }}>
						<Navbar />
						<HomeRoutes />
					</Grid>
					{!(window.innerWidth < 960) && (
						<Grid item xs={1} sm={1} md={8} lg={9} xl={9} style={{ height: "100%" }}>
							<Cover src={data.gallery && data.gallery.cover} />
						</Grid>
					)}
				</Grid>
			</Loading>
		</HomeState.Provider>
	)
}

export default Main